import axios from "axios";

export const axiosUploadFile = (url: string, file: any) => {
  const type =
    file.type && file.type !== "" ? file.type : "application/octet-stream";
  return axios.put(url, file, {
    headers: {
      "Content-Type": type,
    },
  });
};

export const fileBlobToDataUrl = (file: File): Promise<string> => {
  const reader = new FileReader();
  return new Promise((resolve, reject) => {
    reader.readAsDataURL(file);
    reader.onerror = () => {
      reader.abort();
      reject(new DOMException("Cannot convert file"));
    };
    reader.onloadend = () => {
      const base64data = reader.result;
      resolve(base64data ? base64data.toString() : "");
    };
  });
};

export const getPublicUrl = (url: string) => url.split("?")[0];

export const base64toBlob = (
  base64String: string,
  contentType: string,
  sliceSize?: number,
): any => {
  sliceSize = sliceSize || 512;

  const byteCharacters = atob(base64String);
  const byteArrays = [];

  for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    const slice = byteCharacters.slice(offset, offset + sliceSize);
    const byteNumbers = new Array(slice.length);
    for (let i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  const blob = new Blob(byteArrays, { type: contentType });
  return blob;
};

export const downloadBase64ToFile = (
  base64String: string,
  fileType: string,
  fileName: string,
) => {
  // For IE and Edge
  const _window = window as any;
  if (_window?.navigator.msSaveOrOpenBlob) {
    const fileBlob = base64toBlob(base64String, fileType);
    _window.navigator.msSaveOrOpenBlob(fileBlob, fileName);
  } else {
    const linkSource = `data:${fileType};base64,${base64String}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
    if (downloadLink.parentNode) {
      downloadLink.parentNode.removeChild(downloadLink);
    }
  }
};

export const getBase64 = (file: any): any => {
  return new Promise((resolve) => {
    // Make new FileReader
    let reader = new FileReader();
    // Convert the file to base64 text
    reader.readAsDataURL(file);
    // on reader load somthing...
    reader.onload = () => {
      // Make a fileInfo Object
      const baseURL = reader.result;
      if (baseURL) resolve(baseURL);
    };
  });
};

export const attributesFile = (fileString: string) => {
  const attributes = fileString.split(";");
  const data = attributes[0].split(":");
  const file = attributes[1].split("base64,");
  return { type: data[1], base64: file[1] };
};

export const base64ToUrl = (base64: string, type: string) => {
  if (isBase64(base64)) {
    const blob = base64toBlob(base64, type);
    const blobUrl = URL.createObjectURL(blob);
    return blobUrl;
  }
  return "";
};

export const base64FileHeaderMapper = (fileBase64: string) => {
  let fileHeader = new Map();

  //get the first 3 char of base64
  fileHeader.set("/9j", "image/jpg");
  fileHeader.set("iVB", "image/png");
  fileHeader.set("Qk0", "image/bmp");
  fileHeader.set("SUk", "image/tiff");
  fileHeader.set("JVB", "application/pdf");
  fileHeader.set("UEs", "application/msword");

  let res = "";
  fileHeader.forEach((v, k) => {
    if (k == fileBase64.substr(0, 3)) {
      res = v;
    }
  });
  //return map value
  return res;
};

export const isBase64 = (base64Data: string) => {
  const base64Rejex =
    /^(?:[A-Z0-9+\/]{4})*(?:[A-Z0-9+\/]{2}==|[A-Z0-9+\/]{3}=|[A-Z0-9+\/]{4})$/i;
  const isBase64Valid = base64Rejex.test(base64Data); // base64Data is the base64 string
  return isBase64Valid;
};

export const splitFileTypeExt = (
  filetype: string | null | undefined,
): { type: string; ext: string } => {
  let fileTypeExt = { type: "", ext: "" };
  if (!!filetype) {
    const split = filetype.split("/");
    fileTypeExt = { type: split[0], ext: split[1] };
  }
  return fileTypeExt;
};
